<script setup>
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import FormField from './FormField.vue';

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  label: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const setName = (index, value) => {
  const names = [...props.modelValue];
  names[index] = value;
  emit('update:modelValue', names);
};

const addName = () => emit('update:modelValue', [...props.modelValue, '']);

const removeName = index =>
  emit(
    'update:modelValue',
    props.modelValue.filter((_, itemIndex) => itemIndex !== index)
  );
</script>

<template>
  <FormField :label="label">
    <div class="flex flex-col gap-2">
      <div
        v-for="(name, index) in modelValue"
        :key="index"
        class="flex items-center gap-2"
      >
        <Input
          :model-value="name"
          size="sm"
          class="flex-1"
          @update:model-value="setName(index, $event)"
        />
        <Button
          ghost
          xs
          ruby
          icon="i-lucide-x"
          :label="t('CONTACTS_LAYOUT.SIDEBAR.BOOKINGS.FORM.REMOVE')"
          @click="removeName(index)"
        />
      </div>
      <Button
        ghost
        xs
        icon="i-lucide-plus"
        class="self-start"
        :label="t('CONTACTS_LAYOUT.SIDEBAR.BOOKINGS.FORM.ADD_NAME')"
        @click="addName"
      />
    </div>
  </FormField>
</template>
